import React from 'react';
import GameResultTable from '../resultTable/GameResultTable'
import ReactGA from 'react-ga';
import { Divider } from 'semantic-ui-react'
import { GA_TRACKING_RESULTS_PAGE } from '../helpers/AppConsts'

class Results extends React.Component {

  componentDidMount(){
    ReactGA.ga('send', 'pageview', GA_TRACKING_RESULTS_PAGE);
  }

  render () {
    return (
      <React.Fragment>
        <div className="ui container">
          <h3 className="ui header">
            <span style={{color:'#008000' }}>
              <br/>
              Latest Regional Results
            </span>
          </h3>
          <GameResultTable showRows={100}/>
            <Divider hidden/>
              {/* <Link to ="/" style={{color:'black'}} >
                <button className="ui button primary" >
                  Return
                </button>
              </Link> */}
        </div>
        {/* <Footer/> */}
      </React.Fragment>
    )
  }
}

export default Results;
